import builder from '../builder';
import MultipleCircle from '../../streamline-icons/light/multiple-circle.svg';

export default builder('IconMultipleCircleLight', MultipleCircle);
